import Vue from 'vue';
import Buefy from 'buefy';
import App from './App';
import router from '@/router';
import store from '@/store';
import { i18n } from '@/plugins/i18n-setup';
import * as filters from '@/filters';
import useHttpRequestInterceptor from '@/core/httpRequestInterceptor';
import appStore from '@/store/app';
import { Environment, Api } from '@/types';
import { ValidationProvider, configure, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

/* Styles */
import '@/scss/main.scss';

/*Font Awesome ICONS */
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faCheck, faCheckCircle, faInfoCircle, faExclamationTriangle, faExclamationCircle,
  faArrowUp, faAngleRight, faAngleLeft, faAngleDown,
  faEye, faEyeSlash, faCaretDown, faCaretUp, faUpload,
  faUser, faUsers, faBars, faChevronUp, faChevronDown, faChevronLeft, faWallet, faEllipsisV, faEllipsisH,
  faSignOutAlt, faCogs, faUserCircle, faTimes, faBook, faCreditCard,
  faStore, faPlus, faPlusCircle, faMinusCircle, faMinus, faEnvelope, faUserTag, faSync, faKey, faEdit, faUndo, faSave, faFrown, faSearch,
  faShoppingCart, faHourglass, faFileImport, faMoon, faSun, faArrowAltCircleLeft, faPaperPlane, faCartPlus, faCartArrowDown, faServer,
  faPrint, faMoneyBillAlt, faFileInvoice, faBoxes, faTruckLoading, faAd, faCalendarAlt, faCheckDouble, faBan, faUserMd, faPills
} from '@fortawesome/free-solid-svg-icons';

Vue.config.productionTip = false;

if (process.env.NODE_ENV === Environment.Development) {
  Vue.config.performance = true;
  // Vue.config.errorHandler = (error) => {
  //   console.log('Exception', error);
  // };
}

library.add(faCheck, faCheckCircle, faInfoCircle, faExclamationTriangle, faExclamationCircle,
  faArrowUp, faAngleRight, faAngleLeft, faAngleDown,
  faEye, faEyeSlash, faCaretDown, faCaretUp, faUpload,
  faUser, faUsers, faBars, faChevronUp, faChevronDown, faChevronLeft, faWallet, faEllipsisV, faEllipsisH,
  faSignOutAlt, faCogs, faUserCircle, faTimes, faBook, faCreditCard,
  faStore, faPlus, faPlusCircle, faMinusCircle, faMinus, faEnvelope, faUserTag, faSync, faKey, faEdit, faUndo, faSave, faFrown, faSearch,
  faShoppingCart, faHourglass, faFileImport, faMoon, faSun, faArrowAltCircleLeft, faPaperPlane, faCartPlus, faCartArrowDown, faServer,
  faPrint, faMoneyBillAlt, faFileInvoice, faBoxes, faTruckLoading, faAd, faCalendarAlt, faCheckDouble, faBan, faUserMd,
  faPills);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.filter('formatDate', filters.formatDate);
Vue.filter('formatTime', filters.formatTime);
Vue.filter('formatDateTime', filters.formatDateTime);
Vue.filter('formatCurrency', filters.formatCurrency);
Vue.filter('formatNumber', filters.formatNumber);
Vue.filter('formatPercentage', filters.formatPercentage);
Vue.filter('addDays', filters.addDays);
Vue.filter('formatBooleanShort', filters.formatBooleanShort);
Vue.filter('formatBooleanLong', filters.formatBooleanLong);

if (process.env.NODE_ENV === Environment.Development) {
  Vue.filter('jsonPretty', filters.jsonPretty);
}

/* Vue. Component in recursion */
import AsideMenuList from '@/components/AsideMenuList';

/* These components are used in recursion algorithm. they must be registered here */
Vue.component('AsideMenuList', AsideMenuList);

Vue.use(Buefy, {
  // defaultFieldLabelPosition: 'on-border',
  defaultIconComponent: 'font-awesome-icon',
  defaultIconPack: 'fas',
  defaultUseHtml5Validation: true,
  customIconPacks: {
    fas: {
      sizes: {
        'default': '1x',
        'is-small': 'xs',
        'is-medium': '2x',
        'is-large': '3x',
      },
      iconPrefix: '',
    },
  },
});

Vue.component('ValidationProvider', ValidationProvider);

configure({
  classes: {
    valid: 'is-valid',
    invalid: ['is-danger'],
  },
});

extend('required', required);
extend('required', (value) => {
  if (!!value) {
    return true;
  }

  return 'Campo obbligatorio';
});

// Axios interceptor configuration
const apiConfiguration = new Api(process.env.VUE_APP_API_VERSION as string);
const requestTimeout: number = process.env.VUE_APP_AXIOS_TIMEOUT as number;
useHttpRequestInterceptor(apiConfiguration.version, requestTimeout);

const mountApplication = (): void => {
  new Vue({
    i18n,
    router,
    store,
    render: (h) => h(App),
  })
    .$mount('#app');
};

appStore.getConfigurationAsync()
  .then(() => {
    mountApplication();
  });

